
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, makeStyles, mergeClasses, shorthands } from '@fluentui/react-components';
import { AddRegular } from '@fluentui/react-icons';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const useStyles = makeStyles({
  buttonContainer: {
    width: '170px',
    ...shorthands.border('1px', 'dashed', '#c8c6c4'),
    height: '96px',
    display: 'flex',
    ...shorthands.borderRadius('6px'),
  },
  buttonContainerMultiple: {
    width: '112px',
    height: '99px',
  },
  button: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  addIcon: {
    color: '#0078D4',
    fontSize: '32px',
  },
  addIconMultiple: {
    fontSize: '22px',
  },
});

export const AddVideoButton = ({ onClick, multiVideoMode }) => {
  const classes = useStyles();
  const i18n = useContext(I18nContext);

  return (
    <div className={mergeClasses(classes.buttonContainer, 'add-video', multiVideoMode && classes.buttonContainerMultiple)}>
      <Button appearance="transparent" className={classes.button} onClick={onClick} aria-label={i18n.getString(_TL_('Add Video Button'))}>
        <AddRegular className={mergeClasses(classes.addIcon, multiVideoMode && classes.addIconMultiple)} />
      </Button>
    </div>
  );
};

AddVideoButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  multiVideoMode: PropTypes.bool,
};

AddVideoButton.defaultProps = {
  multiVideoMode: false,
};
